import { Route, Routes } from 'react-router-dom'
import { TableMovementsHistory } from './Table/table'

export const BrowserMovementsHistory = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableMovementsHistory />} />
        </Routes>
    );
}
